export function authHeader() {
    // return authorization header with basic auth credentials
    let user = JSON.parse(localStorage.getItem('user'));
    if (user && user.token) {
        var ret = { 'Authorization': 'Bearer ' + user.token };
        return ret;
    } else {
        return {};
    }
}
export function authHeaderId(id) {
    // return authorization header with basic auth credentials
    let user = JSON.parse(localStorage.getItem('user'));
    if (user && user.token) {
        var ret = { 'Authorization': 'Bearer ' + user.token, 'FileId':id };
        return ret;
    } else {
        return {};
    }
}
export function getToken() {
    // return authorization header with basic auth credentials
    let user = JSON.parse(localStorage.getItem('user'));
    if (user && user.token) {
        var ret = 'Bearer ' + user.token;
        return ret;
    } else {
        return '';
    }
}

export function authHeaderJson() {
    // return authorization header with basic auth credentials
    let user = JSON.parse(localStorage.getItem('user'));
    if (user && user.token) {
        var ret = { 'Authorization': 'Bearer ' + user.token, 'Content-Type': 'application/json' };
        return ret;
    } else {
        return {};
    }
}


// WEBPACK FOOTER //
// ./src/components/auth-header.js